@if (loading && style =='vertical') {
  <div class="loader-center">
    @if (showAa) {
      <div style="padding-bottom: 10px;padding-top:10px;"><img style="width: 50px;" src='assets/AAFlag.png'
      alt="American Airlines"></div>
    }
    <div style="padding-bottom: 10px;">{{text}}</div>
    @if (showSpinner) {
      <div style="padding-bottom: 10px; padding-left: 10px;"><img src='assets/spinner.gif'></div>
    }
  </div>
}
@if (loading && style =='horizontal') {
  <div class="loader-center">
    <table>
      <tr>
        <td style="padding: 5px;">@if (showAa) {
          <img style="width: 50px;" src='assets/AAFlag.png'
            alt="American Airlines">
        }</td>
        <td style="padding: 5px;">@if (showSpinner) {
          <img src='assets/spinner.gif'>
        }</td>
        <td style="padding: 5px;">{{text}}</td>
      </tr>
    </table>
  </div>
}
